
























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { addressStringFromPlace } from '@/common/utils'
import AddressErrorModal from '@/components/AddressErrorModal.vue'
declare var google: any;

if (!google.maps.Polygon.prototype.getBounds) {
  google.maps.Polygon.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds();
    this.getPath().forEach(function (element: any, index: any) { bounds.extend(element); });
    return bounds;
  }
}

const componentForm: any = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_2: "short_name",
  country: "long_name",
  postal_code: "short_name"
}

@Component({
  components: {
    AddressErrorModal
  }
})

export default class AddressInput extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop() readonly bounds!: Array<any>;
  @Prop() readonly address!: GooglePlace;

  error = false
  showSearchResults = false
  autocomplete!: any
  currentAddress = ''
  searchResults = []
  service = new google.maps.places.AutocompleteService()
  $refs!: {
    autocomplete: HTMLInputElement;
  };
  addressError : string = "";

  onBlurInput() {
    setTimeout(() => {
      this.showSearchResults = false
    }, 350);
  }

  displaySuggestions (predictions: any, status:any) {
    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      this.searchResults = []
      return
    }
    this.searchResults = predictions
  }

  getPlaceDetails (prediction: any) {
    const googlePlacesService = new google.maps.places.PlacesService(this.$refs.autocomplete);
    return new Promise((resolve) => {
        googlePlacesService.getDetails({
        reference: prediction.reference
      }, function(details: any, status: any){
        resolve(details)
      })
    })
  }

  validateAddressWithApi (latitude: string, longitude: string) {
    return this.$store.dispatch('vas/validateAddressWithApi', { latitude, longitude})
  }

  isCurrentAddressValid () {
    return new Promise((resolve, reject) => {
      this.service.getPlacePredictions({ input: this.currentAddress }, (predictions: any, status: any) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
          return reject(null)
        }
        this.selectLocation(predictions[0]).then(resolve).catch(reject)
      })
    })
  }

  async selectLocation (prediction: any) {
    this.error = false
    this.showSearchResults = false
    const details: any = await this.getPlaceDetails(prediction)

    this.addressError = "";

    const selectedPlace = this.fillInAddress(details)
    if(!selectedPlace.street_number)
    {
      this.currentAddress = "";
      this.addressError = "Seleziona un indirizzo completo";
      return;
    }

    try {
      const { lat, lng }: any = details.geometry.location.toJSON()
      await this.validateAddressWithApi(lat, lng)
      this.currentAddress = addressStringFromPlace(selectedPlace)

    } catch (error) {
      this.error = true
      this.currentAddress = addressStringFromPlace(selectedPlace)
      throw error
    }
  }

  created () {
    if (this.address) {
      this.currentAddress = addressStringFromPlace(this.address)
    }
  }

  @Watch('currentAddress')
  handleAddress () {
    this.service.getPlacePredictions({ input: this.currentAddress }, this.displaySuggestions)
  }

  fillInAddress (place: any) {
    const address: any = {}

    for (const component of place.address_components) {
      const addressType = component.types[0]

      if (componentForm[addressType]) {
        address[addressType] = component[componentForm[addressType]]
      }
    }
    this.$emit('select', { address, place })
    return address
  }
}
